module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Black.5173b0bfa8af145e7c4f921534ede774.ttf";